import type { Canvas, StaticCanvas, FabricObject } from 'fabric';

// A group exposes getObjects(); other objects (text, paths) don't. Return [] for non-groups.
const childrenOf = (obj: unknown): FabricObject[] => {
  const g = obj as { getObjects?: () => FabricObject[] } | null;
  return g && typeof g.getObjects === 'function' ? g.getObjects() : [];
};

// Dugout ships ONE recolourable SVG per shape (with a `js-main-color` element) and paints it per team
// at CREATION; the dataless export keeps only the sourcePath + the group's `color`, so a reload
// restores the RAW uncoloured artwork. Re-apply the team colour after enliven — mirroring Dugout's own
// importer (`serialize/importJSON.js`): skip entirely in `alternateIcon` mode (the neutral shapes keep
// their own fill), and only shirts/caps carry a recolourable main element. Dugout-only (gated at the
// call site in importJSON) so every other theme, which ships pre-coloured SVGs, is untouched.
const recolorDugoutImport = (
  canvas: Canvas | StaticCanvas,
  iconType: string | undefined,
): void => {
  if (iconType === 'alternateIcon') return;

  for (const obj of canvas.getObjects()) {
    const group = obj as FabricObject & { variation?: string; color?: string };
    if (!group.color) continue;
    const variation = group.variation ?? '';
    if (!variation.includes('shirt') && !variation.includes('cone')) continue;

    // The outer group is [svgGroup, (text)]; the recolourable element lives in the svg child. Fall
    // back to the first child when the SVG carries no explicit `js-main-color` id.
    const svgChildren = childrenOf(childrenOf(obj)[0]);
    const main =
      svgChildren.find(
        (c) => (c as FabricObject & { id?: string }).id === 'js-main-color',
      ) ?? svgChildren[0];
    main?.set({ fill: group.color });
  }

  canvas.requestRenderAll();
};

export default recolorDugoutImport;
